import { format, isToday, isYesterday } from "date-fns";

export const getFormattedDateLabel = (dateString) => {
  const date = new Date(dateString);
  if (isToday(date)) return "Today";
  if (isYesterday(date)) return "Yesterday";
  return format(date, "EEEE"); // e.g., Sunday, Monday, etc.
};